import { createLexer, type Token } from "@theprelude/lalr-parser";

const rules = [
  // Keywords and operators (same as above)
  { name: "and", regex: /\band\b/i },
  { name: "or", regex: /\bor\b/i },
  { name: "not", regex: /\bnot\b/i },
  { name: "eq", regex: /\beq\b/i },
  { name: "ne", regex: /\bne\b/i },
  { name: "lt", regex: /\blt\b/i },
  { name: "le", regex: /\ble\b/i },
  { name: "gt", regex: /\bgt\b/i },
  { name: "ge", regex: /\bge\b/i },
  { name: "in", regex: /\bin\b/i },
  { name: "has", regex: /\bhas\b/i },
  { name: "add", regex: /\badd\b/i },
  { name: "sub", regex: /\bsub\b/i },
  { name: "mul", regex: /\bmul\b/i },
  { name: "div", regex: /\bdiv\b/i },
  { name: "divby", regex: /\bdivby\b/i },
  { name: "mod", regex: /\bmod\b/i },
  { name: "any", regex: /\bany\b/i },
  { name: "all", regex: /\ball\b/i },

  // Literals
  { name: "booleanLiteral", regex: /\b(true|false)\b/i },
  { name: "nullLiteral", regex: /\bnull\b/i },
  { name: "durationLiteral", regex: /\bduration'[^']*'/i },
  { name: "stringLiteral", regex: /'(?:[^']|'')*'/ },
  {
    name: "numberLiteral",
    regex:
      /(?:\b(?:NaN|INF|-INF)\b)|(?:[+-]?(?:\d+\.?\d*|\.\d+)(?:[Ee][+-]?\d+)?)/,
  },

  // Built-in method names as a single category
  {
    name: "methodName",
    regex:
      /\b(contains|startswith|endswith|length|indexof|substring|tolower|toupper|trim|concat|year|month|day|hour|minute|second|round|floor|ceiling|now|mindatetime|maxdatetime)\b/i,
  },

  // Custom method names as a separate category
  {
    name: "methodName",
    regex: /\b(matchespattern)\b/i,
  },

  // Identifiers (must come after method names and keywords)
  { name: "identifier", regex: /[A-Z_a-z]\w*/ },

  // Punctuation
  { name: "(", regex: /\(/ },
  { name: ")", regex: /\)/ },
  { name: ",", regex: /,/ },
  { name: "/", regex: /\// },
  { name: ":", regex: /:/ },
  { name: "'", regex: /'/ },
  { name: "minus", regex: /-/ },

  // Whitespace
  { name: "whitespace", regex: /\s+/, discard: true },
] as const;

export type ODataTokenType = (typeof rules)[number]["name"];
export type ODataToken<T extends ODataTokenType = ODataTokenType> = Token<T>;

const odataLexer = createLexer<ODataTokenType>([...rules]);

export const lex = (str: string): ODataToken[] => {
  const { complete, offset, tokens } = odataLexer(str);

  if (!complete) {
    throw new Error(`Unexpected character at position ${offset}`);
  }

  return tokens;
};
